import axios from "axios";
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}`;

const getReadCsCenterInquiryList = async (
  offset,
  pageSize,
  searchType,
  inquiryType,
  orderBy,
  totalYN,
) => {
  const { data } = await axios.get(
    `${baseUrl}/csCenter/read/admin?offset=${offset}&pageSize=${pageSize}&searchType=${searchType}&inquiryType=${inquiryType}&orderBy=${orderBy}&totalYN=${totalYN}`,
  );
  return data;
};

const postUpdateCsCenterInquiry = async (param) => {
  const { data } = await axios.post(`${baseUrl}/csCenter/edit/admin`, param);
  return data;
};

const csCenterApi = {
  getReadCsCenterInquiryList,
  postUpdateCsCenterInquiry,
};

export default csCenterApi;
